module.exports = __webpack_public_path__ + "static/img/anxun13.c2dfcbfe.png";